import * as React from "react";
const DownloadSVG = (props) => (
  <svg
    width={14}
    height={19}
    viewBox="0 0 14 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 13L6.29289 13.7071L7 14.4142L7.70711 13.7071L7 13ZM8 1C8 0.447715 7.55229 2.86409e-07 7 2.62268e-07C6.44772 2.38127e-07 6 0.447715 6 1L7 1L8 1ZM1 7L0.292893 7.70711L6.29289 13.7071L7 13L7.70711 12.2929L1.70711 6.29289L1 7ZM7 13L7.70711 13.7071L13.7071 7.70711L13 7L12.2929 6.29289L6.29289 12.2929L7 13ZM7 13L8 13L8 1L7 1L6 1L6 13L7 13Z"
      fill="#F2F2F2"
    />
    <path d="M0 18L14 18" stroke="#F2F2F2" strokeWidth={2} />
  </svg>
);
export default DownloadSVG;
